// File: ThemeContainer.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';

const ThemeContainer = ({
                            colData = null, // Array of content for each column
                            containerClass = '',
                            containerID = null,
                            fluid = false,
                            rowClass = '',
                            colClassName = '',
                            containerProps = {},
                            rowProps = {},
                            colProps = {},
                            colStyles = {},
                            colSizes = { xs: 12 },
                            colOffsets = {},
                            columns = null, // Number of columns if colData is not used
                            children, // Fallback content if colData is not provided
                        }) => {
    const containerClassName = classNames(containerClass, containerProps.className, {
        'container-fluid': fluid,
        container: !fluid,
    });

    const renderColumns = () => {
        // Check if colData is provided, dynamically render columns for each item in colData
        if (colData && Array.isArray(colData)) {
            const colWidth = columns ? Math.floor(12 / columns) : Math.floor(12 / colData.length);
            return colData.map((data, index) => (
                <Col
                    key={`col-${index}`}
                    className={colClassName}
                    style={colStyles}
                    {...colProps}
                    xs={colWidth}
                    {...(colSizes || {})}
                >
                    {data}
                </Col>
            ));
        }

        // Render columns based on `columns` or `colSizes`
        if (columns) {
            const colWidth = Math.floor(12 / columns);
            return Array.from({ length: columns }).map((_, index) => (
                <Col
                    key={`col-${index}`}
                    className={colClassName}
                    style={colStyles}
                    {...colProps}
                    xs={colWidth}
                >
                    {children}
                </Col>
            ));
        }

        // Use colSizes for custom column widths if no columns or colData provided
        return Object.entries(colSizes).map(([size, width]) => (
            <Col
                key={`col-${size}`}
                className={colClassName}
                style={colStyles}
                {...colProps}
                {...(colOffsets[size] || {})}
                {...{ [size]: width }}
            >
                {children}
            </Col>
        ));
    };

    return (
        <Container
            id={containerID || undefined}
            className={containerClassName}
            fluid={fluid}
            {...containerProps}
        >
            <Row className={rowClass} {...rowProps}>
                {renderColumns()}
            </Row>
        </Container>
    );
};

export default React.memo(ThemeContainer);
